import {Izbor} from "../../../komponente/izbor/Izbor";
import podaci from './podaci.json';

export default class OpsadaKraljeva extends Izbor {
  constructor() {
    super(podaci);
  }
}



// WEBPACK FOOTER //
// ./src/hronologija/1941/10-10/Kraljevo.js